module.exports = __webpack_public_path__ + "assets/202509252035/img/logo.223e0a08.png";